import { post } from '@/redux/requests/api.js';
import normalizeRequestFailure from '@/redux/requests/lib/normalizeRequestFailure.js';

const postOnboardingIntroChatMessage = ({ messages = [], signal } = {}, callback) => {
  return post('/v1/pieve/onboarding/intro-chat/message', {
    callback,
    companyId: null,
    loader: 'postOnboardingIntroChatMessage',
    signal,
    data: { messages },
    onResponse: (responseShape) => {
      return normalizeRequestFailure({
        responseShape,
        fallbackMessage: 'Failed to continue onboarding chat'
      });
    }
  });
};

export default postOnboardingIntroChatMessage;
